var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethods = function SvgPaymentMethods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.43,
    y1: 186.04,
    x2: 155.48,
    y2: 18.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 94.03,
    y1: 244.05,
    x2: 228.07,
    y2: 76.3,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -43.2,
    y1: 134.39,
    x2: 90.84,
    y2: -33.36,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -35.08,
    y1: 140.88,
    x2: 98.96,
    y2: -26.86,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -26.95,
    y1: 147.38,
    x2: 107.09,
    y2: -20.37,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1.96,
    y1: 167.35,
    x2: 132.09,
    y2: -0.4,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 6.17,
    y1: 173.84,
    x2: 140.21,
    y2: 6.1,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 14.3,
    y1: 180.34,
    x2: 148.34,
    y2: 12.59,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -18.82,
    y1: 153.87,
    x2: 115.22,
    y2: -13.87,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 22.43,
    y1: 186.83,
    x2: 156.47,
    y2: 19.09,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,103.38h-10V3.38c0-1.35-.81-2.56-2.07-3.07-1.24-.52-2.67-.25-3.63.7l-7.63,7.67-7.63-7.67c-1.18-1.18-3.04-1.3-4.37-.3l-11.33,8.5L122.15.72c-1.18-.9-2.82-.9-4,0l-11.33,8.5L95.49.72c-1.18-.9-2.82-.9-4,0l-11.33,8.5L68.83.72c-1.18-.9-2.82-.9-4,0l-11.33,8.5L42.16.72c-1.18-.9-2.82-.9-4,0l-11.33,8.5L15.5.72c-1.01-.76-2.37-.87-3.5-.3-1.13.55-1.85,1.71-1.83,2.97v193.32c-.01,1.26.7,2.42,1.83,2.97,1.13.57,2.48.46,3.5-.3l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.33,1,3.19.88,4.37-.3l7.63-7.67,7.63,7.67c.63.62,1.48.97,2.37.97.44.01.87-.08,1.27-.27,1.25-.5,2.07-1.72,2.07-3.07v-23.33h10c5.52-.02,9.98-4.48,10-10v-50c-.02-5.52-4.48-9.98-10-10ZM163.48,188.67l-4.3-4.33c-1.31-1.3-3.42-1.3-4.73,0l-7.93,7.97-11.03-8.27c-1.18-.9-2.82-.9-4,0l-11.33,8.5-11.33-8.5c-1.18-.9-2.82-.9-4,0l-11.33,8.5-11.33-8.5c-1.18-.9-2.82-.9-4,0l-11.33,8.5-11.33-8.5c-1.18-.9-2.82-.9-4,0l-11.33,8.5-11.33-8.5c-1.18-.9-2.82-.9-4,0l-8,6V10.05l8,6c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.33-8.5,11.33,8.5c1.18.9,2.82.9,4,0l11.03-8.27,7.93,7.97c1.31,1.3,3.42,1.3,4.73,0l4.3-4.33v91.96h-69.99c-5.52.02-9.98,4.48-10,10v50c.02,5.52,4.48,9.98,10,10h69.99v15.3ZM183.48,163.37c0,1.84-1.49,3.33-3.33,3.33h-86.66c-1.84,0-3.33-1.49-3.33-3.33v-30h93.33v30ZM183.48,126.71h-93.33v-3.33h93.33v3.33ZM183.48,116.71h-93.33v-3.33c0-1.84,1.49-3.33,3.33-3.33h86.66c1.84,0,3.33,1.49,3.33,3.33v3.33Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.48,163.37h13.33c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-13.33c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33ZM158.48,153.37h13.33c.92,0,1.67.75,1.67,1.67s-.75,1.67-1.67,1.67h-13.33c-.92,0-1.67-.75-1.67-1.67s.75-1.67,1.67-1.67Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,30.05h-11.36c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h11.36c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,46.71h-11.36c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h11.36c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,63.38h-11.36c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h11.36c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,36.71h83.45c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z",
    style: {
      fill: "url(#g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,53.38h83.45c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z",
    style: {
      fill: "url(#h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,70.05h83.45c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33H63.37c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z",
    style: {
      fill: "url(#i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 80.04,
    width: 18.02,
    height: 6.67,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.04,
    y: 80.04,
    width: 90.12,
    height: 6.67,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#k)",
      strokeWidth: 0
    }
  }));
};
export default SvgPaymentMethods;